import { render, staticRenderFns } from "./MailInboxChart.vue?vue&type=template&id=62ec9114&scoped=true"
import script from "./MailInboxChart.vue?vue&type=script&lang=js"
export * from "./MailInboxChart.vue?vue&type=script&lang=js"
import style0 from "./MailInboxChart.vue?vue&type=style&index=0&id=62ec9114&prod&lang=scss"
import style1 from "./MailInboxChart.vue?vue&type=style&index=1&id=62ec9114&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ec9114",
  null
  
)

export default component.exports